import { createAction } from 'redux-actions'

const prefix = 'Notifications:'
export const REMOVE_NOTIFICATION = `${prefix} Remove notification.`
export const ADD_NOTIFICATION = `${prefix} Add notification.`

const addNotification = createAction(
  ADD_NOTIFICATION,
  ({ message, type, action = 'OK', dismissAfter = 4000 }) => ({
    message,
    type,
    action,
    dismissAfter,
    key: Date.now(),
  }),
)
const addErrorNotification = (message, action = 'OK') =>
  addNotification({
    message,
    action,
    type: 'error',
  })
const removeNotification = createAction(REMOVE_NOTIFICATION)

export const actionCreators = {
  removeNotification,
  addNotification,
  addErrorNotification,
}
